import type { FeedbackItemRef } from "../types";

/** Stable key for list rows and React keys. */
export function feedbackItemKey(ref: FeedbackItemRef): string {
  return `${ref.workspace_id}:${ref.thread_id}:${ref.assistant_message_index}`;
}

/** Detail route path for a feedback item (query string preserved by caller). */
export function buildFeedbackDetailPath(ref: FeedbackItemRef): string {
  return `/eval-steward/${ref.workspace_id}/${ref.thread_id}/${ref.assistant_message_index}`;
}
